"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIMUM_TIME_BETWEEN_FAILED_REFRESHES_IN_SECONDS = exports.ACCESS_TOKEN_REFRESH_MAX_BACKOFF_TIME_IN_SECONDS = exports.ACCESS_TOKEN_REFRESH_FALLBACK_TIME_IN_SECONDS = exports.ACCESS_TOKEN_REFRESH_BEFORE_EXPIRATION_IN_SECONDS = void 0;
exports.ACCESS_TOKEN_REFRESH_BEFORE_EXPIRATION_IN_SECONDS = 10 * 60;
exports.ACCESS_TOKEN_REFRESH_FALLBACK_TIME_IN_SECONDS = 5;
exports.ACCESS_TOKEN_REFRESH_MAX_BACKOFF_TIME_IN_SECONDS = 10;
exports.MINIMUM_TIME_BETWEEN_FAILED_REFRESHES_IN_SECONDS = 5;
